<div class="ui-dashboard">

  <div class="dashboard-wrapper">

    <!-- Heading & Dates -->
    <div class="grid grid-gap-5 grid-2x-responsive">
      <div class="custom-heading">
        <!-- <h3 class="heading"> Workflow Name: {{dataTransferService.currentWorkflow.workflowDO.workflowName}}</h3> -->
        <!-- <nz-tag [nzColor]="'#2db7f5'"
          style="margin-bottom: 10px; margin-left: 5px;">{{dataTransferService.currentWorkflow.workflowDO.statusCd}}</nz-tag> -->
      </div>
    </div>
    <div class="search-results m-t-20" *ngIf="true">
      <!-- <nz-table [nzData]="dataSet" [nzShowPagination]="false">
        <thead>
          <tr>
            <th>Workflow Name</th>
            <th>Application ID</th>
            <th>Company Name</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><input nz-input [(ngModel)]="dataTransferService.currentWorkflow.workflowDO.workflowName" />
            </td>
            <td>
              <input nz-input [(ngModel)]="dataTransferService.currentWorkflow.workflowDO.applicationID"
                (ngModelChange)="dynamicallyAddStepsToConfigure()" />
            </td>
            <td>
              {{dataTransferService.currentWorkflow.workflowDO.companyName}}
            </td>
          </tr>
        </tbody>
      </nz-table> -->
    </div>
    <div class="m-t-20" *ngIf="false">
      <app-dynamic-form [baseDOName]="'workflowDO'" FORMTITLE="Workflow Details" FORMNAME="workflowDetailsDynamicForm"
        [IO]="payloadInEdit" [currentComponentName]="'workflowDetailsDynamicForm'"
        [formMetaData]="workflowDetailsDynamicForm" (ngModelchange)="workflowDetailsChanged($event)">
      </app-dynamic-form>
    </div>
    <main>
      <div id="palette">
        <div>
          <nz-tag [nzColor]="'grey'"><label nzLabel style="padding: 5px;"> Default
              Palette:</label> </nz-tag>
        </div>
        <section class="palette-border">
          <div class="plugin-op" *ngFor="let op of filterStepsArray(dataTransferService.workflowSteps)"
            [ngFlowchartStep]="op.step">
            <div [ngClass]="op.step.data.name =='State' ? 'state-step' : 'action-step'">
              <ng-container *ngIf="op.step.data.name == 'State'">
                <span style="margin-left: 4em;">{{ op.step.data.name }}</span>
                <span nz-icon nzType="gateway" nzTheme="outline" class="p-10"></span>
              </ng-container>
              <ng-container *ngIf="op.step.data.name == 'Action'">
                <span style="margin-left: 4em;">{{ op.step.data.name }}</span>
                <span nz-icon nzType="subnode" nzTheme="outline" class="p-10"></span>
              </ng-container>
            </div>
            <!-- <div *ngIf="op.step.data.name == 'Data Entry'" class="dataEntry-step">
              <span style="margin-left: 4em;">{{ op.step.data.name }}</span>
              <span nz-icon nzType="form" nzTheme="outline" class="p-10"></span>
            </div> -->
          </div>
        </section>
        <div>
          <nz-tag [nzColor]="'grey'">
            <label nzLabel style="padding: 5px;">
              Additional Palette States:
            </label>
          </nz-tag>
        </div>
        <section class="applicationID-specific-palette">
          <div class="plugin-op"
            *ngFor="let op of filterApplicationSpecificStepsArray(dataTransferService.workflowSteps)"
            [ngFlowchartStep]="op.step">
            <div *ngIf="op.step.data.name == 'Data Entry'" class="dataEntry-step">
              <span style="margin-left: 4em;">{{ op.step.data.name }}</span>
              <span nz-icon nzType="form" nzTheme="outline" class="p-10"></span>
            </div>
            <div *ngIf="op.step.data.name == 'Manual Adjudication'" class="manualAdjudication-step">
              <span style="margin-left: 4em;">{{ op.step.data.name }}</span>
              <span nz-icon nzType="bank" nzTheme="outline" class="p-10"></span>
            </div>
            <div *ngIf="op.step.data.name == 'Auto Adjudication'" class="autoAdjudication-step">
              <span style="margin-left: 4em;">{{ op.step.data.name }}</span>
              <span nz-icon nzType="bank" nzTheme="outline" class="p-10"></span>
            </div>
            <div *ngIf="op.step.data.name == 'Investigation'" class="investigation-step">
              <span style="margin-left: 4em;">{{ op.step.data.name }}</span>
              <span nz-icon nzType="eye" nzTheme="outline" class="p-10"></span>
            </div>
            <div *ngIf="op.step.data.name == 'Payout'" class="payout-step">
              <span style="margin-left: 4em;">{{ op.step.data.name }}</span>
              <span nz-icon nzType="dollar" nzTheme="outline" class="p-10"></span>
            </div>
            <div *ngIf="op.step.data.name == 'Auto Underwriting'" class="autoUnderwriting-step">
              <span style="margin-left: 4em;">{{ op.step.data.name }}</span>
              <span nz-icon nzType="setting" nzTheme="outline" class="p-10"></span>
            </div>
            <div *ngIf="op.step.data.name == 'Manual Underwriting'" class="manualUnderwriting-step">
              <span style="margin-left: 4em;">{{ op.step.data.name }}</span>
              <span nz-icon nzType="solution" nzTheme="outline" class="p-10"></span>
            </div>
            <div *ngIf="op.step.data.name == 'Policy Issuence'" class="policyIssuence-step">
              <span style="margin-left: 4em;">{{ op.step.data.name }}</span>
              <span nz-icon nzType="check" nzTheme="outline" class="p-10"></span>
            </div>
            <div *ngIf="op.step.data.name == 'Policy Reject'" class="policyReject-step">
              <span style="margin-left: 4em;">{{ op.step.data.name }}</span>
              <span nz-icon nzType="close" nzTheme="outline" class="p-10"></span>
            </div>
          </div>
        </section>
        <section>
          <button nz-button (click)="showFlowData()" class="p-20" [nzType]="'secondary'">
            <span>Workflow JSON</span>
            <span nz-icon nzType="download" nzTheme="outline" (click)="showFlowData()"></span>
          </button>
          <button nz-button (click)="showModal()" class="p-20" [nzType]="'secondary'">
            <span>Upload JSON</span>
            <span nz-icon nzType="upload" nzTheme="outline" (click)="showModal()"></span>
          </button>
        </section>
        <ng-template #normalStep let-data>
          <div class="card" [attr.name]="data.data.name" #card (click)="onEntityClick(data)">
            <span>{{ data.data.name }}</span>
          </div>
        </ng-template>
      </div>
      <div id="canvas" ngFlowchartCanvas [ngFlowchartOptions]="{
                stepGap: 40
              }" [ngFlowchartCallbacks]="callbacks"></div>
    </main>
  </div>
  <!-- Primary Save -->
  <div class="card-summary-data-footer data-footer-primary">
    <button nz-button class="b-0 m-r-10" (click)="cancelClicked()">Cancel</button>
    <button nz-button style="margin-left: 80%;" [nzType]="'primary'" (click)="saveClicked()">Save</button>
    <button nz-button [nzType]="'primary'" (click)="submitClicked()">Submit</button>

  </div>
  <!-- /Primary Save -->
</div>

<nz-modal [(nzVisible)]="isVisible" nzTitle="Upload JSON" (nzOnCancel)="handleCancel()"
  (nzOnOk)="showUpload(workflowJSON)">

  <ng-container *nzModalContent class="flex flex-both-center">
    <span>Paste Workflow JSON here : </span>
    <textarea class="memo-input" name="" id="" cols="30" rows="6" [(ngModel)]="workflowJSON"></textarea>
  </ng-container>
</nz-modal>

<div class="m-t-20" *ngIf="stateOrActionAlreadyExist">
  <span>
    <nz-alert nzType="warning" nzCloseable
      nzMessage="Already Exist! Please rename the existing State/Action to try again." nzShowIcon>
    </nz-alert>
  </span>
</div>